import { type JSX, type ReactNode } from "react";
import { type RichTextField } from "@sitecore-content-sdk/nextjs";
import { PageContentProps } from "components/sxa/page-content/page-content.props";
import RichTextWithTable from "../../../molecules/RichTextWithTable/RichTextWithTables";
import { NoDataFallback } from "../../../utils/NoDataFallback";

interface ComponentContentProps {
  id?: string;
  styles?: string;
  children: ReactNode;
}

const ComponentContent = ({ id, styles, children }: ComponentContentProps) => (
  <div
    className={`relative lg:pl-2 lg:pr-2 pl-0 pr-0 overflow-hidden leading-[1.5] text-base ${styles ?? ""}`}
    id={id || undefined}
    data-role="page-content-component"
  >
    <div className="max-w-full">
      <div className="max-w-full">{children}</div>
    </div>
  </div>
);

export const Default = (props: PageContentProps): JSX.Element => {
  console.log("---->[PageContent] Component", props.fields);

  const { page, fields, params } = props;

  // Content can come from the rendering's own datasource (fields.Content) or
  // fall back to the route-level Content field.
  const routeContent = page.layout?.sitecore?.route?.fields?.Content as
    | RichTextField
    | undefined;
  const field: RichTextField | undefined = fields?.Content ?? routeContent;

  if (!field) {
    return <NoDataFallback componentName="Page Content" />;
  }

  return (
    <ComponentContent id={params?.RenderingIdentifier} styles={params?.styles}>
      <RichTextWithTable field={field} />
    </ComponentContent>
  );
};
